// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from '../layout/CustomSelect';
import Loader from '../dashboard/common/Loader';
import { toggleModal } from '../../storage/actions/modalsActions';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../utils/customSelectStyle';
import getCompanyMembers from '../../utils/api/get/getCompanyMembers';
import { delete_user_Details as deleteUserDetails } from '../../storage/actions/authActions';
import Notification from '../notification';

const DeleteClientFromCompany = ({
  deleteUserDetails,
  toggleModal,
  modalState,
}) => {
  const [clientsList, setClientsList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!modalState?.isOpen) {
      return undefined;
    }

    const fetchData = async () => {
      setIsLoading(true);
      const newClientsList = await getCompanyMembers()
        .then((clients) => (
          clients
            .filter((el) => el.userId !== modalState.type.client.userId)
            .map((el) => ({ value: el.userId, label: el.name }))
        ));
      setClientsList(newClientsList);
      setIsLoading(false);
    };

    fetchData();

    return () => {
      setSelectedClient(null);
      setClientsList([]);
      setIsLoading(true);
    };
  }, [modalState?.isOpen]);

  const onClose = () => {
    toggleModal(false, 'deleteClientFromCompany');
  };

  const onSubmit = () => {
    if (!selectedClient?.value) {
      Notification('warning', { message: 'Please, select user first!' });
      return;
    }
    deleteUserDetails(modalState.type.client._id, selectedClient.value);
  };

  if (!modalState?.isOpen) {
    return null;
  }

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="modal_container"
        style={{ minHeight: 'fit-content' }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-client-from-company-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="delete-client-from-company-title">
            Delete User
          </div>
          <button
            type="button"
            className="close_btn icon_close"
            aria-label="close"
            onClick={onClose}
          />
        </div>
        <div className="modal_body">
          <div className="info_block">
            <div className="block_sub">
              Work Orders created by this user should be reassigned to:
            </div>
          </div>
          <div className="field_row">
            <div className="field_name">
              <label htmlFor="reassign_user">User</label>
            </div>
            {isLoading ? (
              <div className="flex-box flex-center">
                <Loader color="black" />
              </div>
            ) : (
              <div className="field_block dashboard-select-wrap">
                <Select
                  inputId="reassign_user"
                  isSearchable
                  options={clientsList}
                  value={selectedClient}
                  styles={dashboardSelectStyle}
                  classNames={dashboardSelectClassNames}
                  onChange={setSelectedClient}
                  placeholder="Select another user"
                />
              </div>
            )}
          </div>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            onClick={onSubmit}
          >
            Delete User
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  deleteUserDetails,
  toggleModal,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.deleteClientFromCompany,
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteClientFromCompany);
